import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetCustomizedDialogsRequests = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}CustomizedDialogs/GetCustomizedDialogs`,
});
